import React from 'react';
import PropTypes from 'prop-types';

import CircularProgress from "@mui/material/CircularProgress";

import Badge from "components/Badge";

StatusBadge.propTypes = {
    process: PropTypes.string,
    hasErrors: PropTypes.bool
};

function StatusBadge({process, hasErrors = false}) {
    switch (process) {
        case 'awaiting_import':
        case 'importing-products':
            return <Badge><CircularProgress size={10}/><span style={{marginLeft:'4px'}}>En cours</span></Badge>
        default:
            return hasErrors
                ? <Badge color={'error'}>À corriger</Badge>
                : <Badge color={'online'}>Terminé</Badge>
    }
}

export default StatusBadge;
